import React from 'react';
interface BICardProps {
  title?: string;
  children: React.ReactNode;
  className?: string;
  action?: React.ReactNode;
}
export function BICard({
  title,
  children,
  className = '',
  action
}: BICardProps) {
  return <div className={`bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-xl border border-white/10 overflow-hidden flex flex-col ${className}`} data-id="element-601" data-mp="9mzb8wufktez">
      {(title || action) && <div className="px-5 py-4 border-b border-white/10 flex items-center justify-between" data-id="element-602" data-mp="jmq4ywb634e0">
          {title && <h3 className="text-white font-semibold text-sm" data-id="element-603" data-mp="ojzt88mtla09">{title}</h3>}
          {action && <div data-id="element-604" data-mp="tb84la7pn5g2">{action}</div>}
        </div>}
      <div className="p-5 flex-1 flex flex-col" data-id="element-605" data-mp="tc9nu1yvqy8v">{children}</div>
    </div>;
}